import { IDispatchRule } from "@/types/dispatchRules.types"
import ModalCard from "@/UI/Modals/ModalCard"
import { useTranslation } from "react-i18next"
import React from "react"
import CreateOrUpdateRuleForm from "../../CreateOrUpdateRuleForm.tsx/CreateOrUpdateRuleForm.container"

interface UpdateRuleModalProps {
  rule: IDispatchRule
  isModalVisible: boolean
  closeModal: () => void
}

const UpdateRuleModal: React.FC<UpdateRuleModalProps> = ({ closeModal, isModalVisible, rule }) => {
  const { t } = useTranslation()
  return (
    <ModalCard
      closable
      isModalVisible={isModalVisible}
      onCancel={closeModal}
      title={t("profile.UpdateRuleModal.updateRule")}
    >
      <CreateOrUpdateRuleForm existingRule={rule} type="update" closeModal={closeModal} />
    </ModalCard>
  )
}

export default UpdateRuleModal
